import { type FC } from 'react';
import styled from 'styled-components';

import { FundPaymentInformation } from '@/api/funds/models/FundPaymentInformation';
import { RenderHtml } from '@/components/RenderHtml';
import { useTexts } from '@/hooks/useTexts';
import { fmsWithTemplate } from '@/i18n/fmsWithTemplate';
import { useUserLocale } from '@/i18n/hooks';
import { getPaymentTitleFromAccountHolder } from '@/pages/Order/utils/getPaymentTitleFromAccountHolder';
import { formatNumber } from '@/util/formatNumber';

interface Props {
  amount: number;
  paymentInfo: FundPaymentInformation;
}

export const ForeignPayment: FC<Props> = ({ amount, paymentInfo }) => {
  const texts = useTexts();
  const locale = useUserLocale();

  const title = fmsWithTemplate(
    texts.orders.form.payment.subscription.settlementAccount.info.title
      .withCurrency,
    {
      name: getPaymentTitleFromAccountHolder(paymentInfo.accountHolder, texts),
      currency: paymentInfo.currency,
    },
  );

  const paymentStepsText =
    texts.orders.form.payment.subscription.settlementAccount.info.steps;

  const formattedAmount = formatNumber(amount, locale);

  const html = fmsWithTemplate(paymentStepsText, {
    name: getPaymentTitleFromAccountHolder(paymentInfo.accountHolder, texts),
    amount: formattedAmount,
    currency: paymentInfo.currency,
    bankAccountNumber: paymentInfo.bankAccountNumber,
    iban: paymentInfo.iban,
    swift: paymentInfo.swift,
  });

  return (
    <Container>
      <H4WithMargin className="font-body-demibold">{title}</H4WithMargin>

      <RenderHtml html={html} />
    </Container>
  );
};

const Container = styled.div`
  line-height: 24px;
`;

const H4WithMargin = styled.h4`
  margin-bottom: 8px;
`;
